export default function Default(props) {
  const { children } = props;

  return <>{children}</>;
}
